export const platformValues = [
  { label: 'zvoove One', value: true },
  { label: 'Expert Mode', value: false },
];
